$shm_hitalama_textbook_tree $shm_tree
